export const ServicesData = [
    {
      id: 1,
      image:'bylaws.svg',
      Hoverd_image:'Hoved_bylaws.svg',
      Title: "مشروعات الأنظمة والتشريعات",
      TitleEn: "Regulatory & Legal Projects",
      description: "إعداد و صياغة الأنظمة  و اللوائح و فق القوانين  المعتمدة.",
      descriptionEn: "Drafting systems and regulations in accordance with approved laws.",
    },
    {
      id: 2,
      image: 'legal consultations.svg',
      Hoverd_image:'Hoverd_legal_consultations.svg',
      Title: "الاستشارات القانونية",
      TitleEn: "Legal Consultations",
      description: "تقديم حلول قانونية متخصصة للأفراد و الشركات",
      descriptionEn: "Providing specialized legal solutions for individuals and companies.",
    },
    {
      id: 3,
      image: 'contract.svg',
      Hoverd_image:'Hoverd_contract.svg',
      Title: "صياغة ومراجعة العقود",
      TitleEn: "Contract Drafting & Review",
      description: "إعداد العقود القانونية  لضمان حقوق الاطراف المتعاقدة.",
      descriptionEn: "Preparing legal contracts to ensure the rights of contracting parties.",
    },
    {
      id: 4,
      image: 'acquisition services.svg',
      Hoverd_image:'Hoverd_acquisition_services.svg',
      Title: "الاندماج والاستحواذ",
      TitleEn: "Mergers & Acquisitions",
      description: "تقديم الدعم القانوني لعمليات الاندماج و الاستحواذ للشركات.",
      descriptionEn: "Providing legal support for corporate mergers and acquisitions.",
    },
    {
      id: 5,
      image: 'governance framework.svg',
      Hoverd_image:'H_governance framework.svg',
      Title: "بناء إطار الحوكمة",
      TitleEn: "Governance Framework Development",
      description: "ندعم المؤسسات في تطوير أطر حوكمة فعالة تعزز الشفافية والاستدامة المؤسسية.",
      descriptionEn: "We support organizations in developing effective governance frameworks that enhance transparency and institutional sustainability.",
    },
    {
      id: 6,
      image: 'compliance services.svg',
      Hoverd_image:'H_compliance services.svg',
      Title: "الالتزام القانوني",
      TitleEn: "Legal Compliance",
      description: "نساعد الشركات على الامتثال للأنظمة والقوانين المحلية والدولية، مما يحد من المخاطر القانونية.",
      descriptionEn: "We help companies comply with local and international laws and regulations, reducing legal risks.",
    },
    {
      id: 7,
      image: 'Judicial representation.svg',
      Hoverd_image:'H_Judicial representation.svg',
      Title: "التمثيل القضائي",
      TitleEn: "Litigation & Legal Representation",
      description: "نوفر تمثيلًا قانونيًا احترافيًا أمام المحاكم والهيئات القضائية وشبه القضائية لضمان الدفاع عن حقوق عملائنا.",
      descriptionEn: "We provide professional legal representation before courts and judicial or quasi-judicial bodies to ensure the defense of our clients' rights.",
    },
    {
      id: 8,
      image: 'companies.svg',
      Hoverd_image:'Hoverd_companies.svg',
      Title: "تأسيس الإدارات القانونية",
      TitleEn: "Establishment of Legal Departments",
      description: "نقدم خدمات متكاملة لتأسيس إدارات قانونية فعالة داخل الشركات، مما يضمن إدارة قانونية احترافية.",
      descriptionEn: "We offer comprehensive services to establish effective legal departments within companies, ensuring professional legal management.",
    },
    {
      id: 9,
      image: 'Secretariat services.svg',
      Hoverd_image:'H_Secretariat services.svg',
      Title: "أمانة سر المجالس",
      TitleEn: "Board Secretariat Services",
      description: "ندعم الشركات والمؤسسات في تنظيم وإدارة اجتماعات مجالس الإدارة واللجان، وضمان الامتثال للوائح الداخلية والخارجية.",
      descriptionEn: "We support companies and institutions in organizing and managing board and committee meetings, ensuring compliance with internal and external regulations.",
    },
    {
      id: 10,
      image: 'Legal support.svg',
      Hoverd_image:'H_Legal support.svg',
      Title: "الدعم القانوني للشركات",
      TitleEn: "Corporate Legal Support",
      description: "نقدم دعمًا قانونيًا شاملاً لمختلف المؤسسات والشركات لضمان الامتثال وحماية الحقوق القانونية.",
      descriptionEn: "We provide comprehensive legal support for various institutions and companies to ensure compliance and protect legal rights.",
    }
  ];
  